import { render, staticRenderFns } from "./HeaderYjjM.vue?vue&type=template&id=b163d2be&scoped=true&"
import script from "./HeaderYjjM.vue?vue&type=script&lang=js&"
export * from "./HeaderYjjM.vue?vue&type=script&lang=js&"
import style0 from "./HeaderYjjM.vue?vue&type=style&index=0&id=b163d2be&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b163d2be",
  null
  
)

export default component.exports